import { atom } from "jotai";

export const currentApplicationId = atom<number>(0);
export const currentApplicantId = atom<number>(0);

export const isAddCoapplicantDirty = atom<{
  [applicationId: number]: boolean | undefined;
}>({});
